/* ------------------------------
   SHOWS MODULE
   Shared logic for shows + about pages
------------------------------ */

function fmtDate(d, opts) {
  if (!d) return '';
  var defaults = { month: 'short', day: 'numeric', year: 'numeric' };
  return new Date(d).toLocaleDateString('en-US', opts || defaults);
}

function safeBands(show) {
  return (show.bands || []).filter(Boolean);
}

function escHtml(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
}

/* Full flyer grid (about page — all shows) */
function renderFlyerGrid(shows, containerId, popupPrefix) {
  var el = document.getElementById(containerId);
  if (!el) return;

  if (!shows.length) {
    el.innerHTML = '<p class="shows-empty" style="padding:0.5rem 0;">No shows yet.</p>';
    return;
  }

  el.innerHTML = shows.map(function(show, i) {
    var label = escHtml(show.venue || 'Show');
    if (show.image) {
      return '<button class="history-flyer" onclick="openFlyerPopup(\'' + popupPrefix + '\',' + i + ')" aria-label="' + label + '">'
        + '<img src="' + escHtml(show.image) + '" alt="' + escHtml(show.venue || 'Show') + '" loading="lazy">'
        + '</button>';
    }
    return '<button class="history-flyer" onclick="openFlyerPopup(\'' + popupPrefix + '\',' + i + ')" aria-label="' + label + '">'
      + '<div class="history-flyer-placeholder"></div>'
      + '</button>';
  }).join('');
}

/* Shared flyer popup open/close */
function openFlyerPopup(prefix, i) {
  var shows = window['_flyerData_' + prefix];
  if (!shows || !shows[i]) return;
  var show = shows[i];
  var popup = document.getElementById(prefix + '-flyer-popup');
  if (!popup) return;

  var img = popup.querySelector('.flyer-popup-img');
  if (img) {
    img.src = show.image || '';
    img.style.display = show.image ? '' : 'none';
    var venue = show.venue || 'Show';
    var altDate = show.date ? fmtDate(show.date) : '';
    img.alt = altDate ? 'Show flyer: ' + venue + ' — ' + altDate : 'Show flyer: ' + venue;
  }

  var dateEl = popup.querySelector('.flyer-popup-date');
  if (dateEl) dateEl.textContent = fmtDate(show.date);

  var venueEl = popup.querySelector('.flyer-popup-venue');
  if (venueEl) venueEl.textContent = show.venue || '';

  var bandsEl = popup.querySelector('.flyer-popup-bands');
  if (bandsEl) bandsEl.textContent = safeBands(show).map(function(b) { return b.name || ''; }).join(', ');

  var descEl = popup.querySelector('.flyer-popup-desc');
  if (descEl) descEl.textContent = show.description || '';

  var ticketEl = popup.querySelector('.flyer-popup-ticket');
  if (ticketEl) {
    if (show.ticket_link) {
      ticketEl.href = show.ticket_link;
      ticketEl.style.display = '';
    } else {
      ticketEl.style.display = 'none';
    }
  }

  popup.classList.remove('hidden');
}

function closeFlyerPopup(prefix) {
  var popup = document.getElementById(prefix + '-flyer-popup');
  if (popup) popup.classList.add('hidden');
}

/* Bind backdrop click to close */
function initFlyerPopup(prefix) {
  var popup = document.getElementById(prefix + '-flyer-popup');
  if (popup) {
    popup.addEventListener('click', function(e) {
      if (e.target === popup) closeFlyerPopup(prefix);
    });
  }
}
